let callbacksMap = {};

export default {
	on(event, callback) {
		if (!callbacksMap[event]) {
			callbacksMap[event] = [];
		}
		callbacksMap[event].push(callback);
	},
	off(event, callback) {
		if (!callbacksMap[event]) return;
		let idx = callbacksMap[event].indexOf(callback);
		if (idx === -1) return;
		callbacksMap[event].splice(idx, 1);
	},
	emit(event, data) {
		if (!callbacksMap[event]) return;
		return callbacksMap[event].map(fn => fn(data))
	}
};